import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { Button, Chip, Grid2 as Grid, ListSubheader, Typography } from '@mui/material';
import { globalstyles } from '../../lib/definitions';
import { AutoFixHigh, FilterAlt, KeyboardArrowDown, KeyboardDoubleArrowDown, Settings } from '@mui/icons-material';


export default function SelectCategoryMenu({ options, handleChoose }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const open = Boolean(anchorEl);
    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        handleChoose(options[index].id)
        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button color="secondary" onClick={handleClickListItem} style={{ display: "block", textAlign: "left" }}>
                <Grid container alignItems={"center"}>
                    <Grid size="auto">
                        <FilterAlt />
                    </Grid>
                    <Grid>

                        <Typography sx={globalstyles.input_label}>
                            Filtra categoria
                        </Typography>
                        <Typography>
                            {options[selectedIndex]?.category_name}
                        </Typography>
                    </Grid>
                    <Grid size="auto">
                        <KeyboardArrowDown />
                    </Grid>
                </Grid>

            </Button>
            <Menu
                id="lock-menu"
                dense
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'lock-button',
                    role: 'listbox',
                }}
            >
                {options.map((option, index) => (
                    <MenuItem
                        key={index}
                        selected={index === selectedIndex}
                        sx={{ color: !option.cow_list || option.cow_list.length === 0 ? '#aaa' : '' }}
                        onClick={(event) => handleMenuItemClick(event, index)}
                    >
                        {option?.category_name}:
                        {option?.category_description}
                        {option.cow_list ? <Chip color={!option.cow_list || option.cow_list.length === 0 ? "light" : "secondary"} size="small" label={<>{option.cow_list.length}</>} /> : ''}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

const section_list = [
    {
        label: 'manuale',
        option_list: [
            { id: 1, label: 'Rimuovi categoria' },
            { id: 2, label: 'Assegna manualmente' },
        ]
    },
    {
        label: 'automatico',
        option_list: [
            { id: 3, label: <>Assegna da campo&nbsp;<i>categoria_ins</i>&nbsp;su csv</> },
            { id: 4, label: 'Assegna usando i filtri nelle categorie' },
        ]
    }
]


export function CategoryMassiveChange({ handleChoose, cow_count }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const open = Boolean(anchorEl);
    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        handleChoose(index)
        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const disabled = cow_count === 0


    const OneSection = ({s}) => {
        return (
            <>

                <ListSubheader>{s.label}</ListSubheader>
                {s.option_list.map((o, k) => (

                <MenuItem
                    disabled={disabled}
                    selected={o.id === selectedIndex}
                    onClick={(event) => handleMenuItemClick(event, o.id)}
                >
                    {o.label}
                </MenuItem>
                ))}
            </>
        )

    }

    return (
        <>
            <Button color="primary" onClick={handleClickListItem} style={{ display: "block", textAlign: "left" }}>
                <Grid container alignItems={"center"}>
                    <Grid size="auto">
                        <AutoFixHigh />
                    </Grid>
                    <Grid>
                        Assegna categorie
                        <Typography sx={globalstyles.input_label}>
                            ai <b>{cow_count} soggetti selezionati</b>
                        </Typography>
                    </Grid>
                    <Grid size="auto">
                        <KeyboardArrowDown />
                    </Grid>
                </Grid>

            </Button>
            <Menu
                id="lock-menu"
                dense
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'lock-button',
                    role: 'listbox',
                }}
            >
                {section_list.map((s,sk) => (
                    <OneSection s={s} key={sk} />

                ))}
               
            </Menu>
        </>
    );
}


